export const SketchTypes = {
  POINT: 'TCAD.TWO.EndPoint',
  SEGMENT: 'TCAD.TWO.Segment',
  ARC: 'TCAD.TWO.Arc',
  CIRCLE: 'TCAD.TWO.Circle',
  ELLIPSE: 'TCAD.TWO.Ellipse',
  ELL_ARC: 'TCAD.TWO.EllipticalArc',
  BEZIER: 'TCAD.TWO.BezierCurve',
  NURBS: 'TCAD.TWO.NurbsObject',
  DIM: 'TCAD.TWO.Dimension',
  HDIM: 'TCAD.TWO.HDimension',
  VDIM: 'TCAD.TWO.VDimension',
  DDIM: 'TCAD.TWO.DiameterDimension',
  ANGLE_BW: 'TCAD.TWO.AngleBetweenDimension',
  LABEL: 'TCAD.TWO.Label',
};

// This for using property TYPE because _class was marked deprecated.
export const ShapesTypes = {
  POINT: 'Point',
  SEGMENT: 'Segment',
  ARC: 'Arc',
  CIRCLE: 'Circle',
  ELLIPSE: 'Ellipse',
  ELL_ARC: 'EllipticalArc',
  BEZIER: 'BezierCurve',
  NURBS: 'NurbsObject',
  DIM: 'Dimension',
  HDIM: 'HDimension',
  VDIM: 'VDimension',
  DDIM: 'DiameterDimension',
  ANGLE_BW: 'AngleBetweenDimension',
  LABEL: 'Label',
};
